module.exports = __webpack_public_path__ + "static/media/metro.95937cb1.svg";